module.exports = __webpack_public_path__ + "static/media/title_bg_8.7fc3ea3a.png";